import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=138e8202&scoped=true"
import script from "./DesktopNav.vue?vue&type=script&lang=ts"
export * from "./DesktopNav.vue?vue&type=script&lang=ts"
import style0 from "./DesktopNav.vue?vue&type=style&index=0&id=138e8202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e8202",
  null
  
)

export default component.exports